import {
  FETCH_ADMIN_ALERT_REQUEST,
  FETCH_ADMIN_ALERT_SUCCESS,
  FETCH_ADMIN_ALERT_FAILURE,
  SAVE_ADMIN_ALERT_REQUEST,
  SAVE_ADMIN_ALERT_SUCCESS,
  SAVE_ADMIN_ALERT_FAILURE,
  DELETE_ADMIN_ALERT_REQUEST,
  DELETE_ADMIN_ALERT_SUCCESS,
  DELETE_ADMIN_ALERT_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  message: null,
  loading: false,
  saving: false,
  deleting: false,
  error: null,
  saveError: null,
  deleteError: null,
};

const adminAlertReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_ALERT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ADMIN_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
        error: null,
      };
    case FETCH_ADMIN_ALERT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SAVE_ADMIN_ALERT_REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case SAVE_ADMIN_ALERT_SUCCESS:
      return {
        ...state,
        saving: false,
        message: action.payload,
        saveError: null,
      };
    case SAVE_ADMIN_ALERT_FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };
    case DELETE_ADMIN_ALERT_REQUEST:
      return {
        ...state,
        deleting: true,
        deleteError: null,
      };
    case DELETE_ADMIN_ALERT_SUCCESS:
      return {
        ...state,
        deleting: false,
        message: null,
        deleteError: null,
      };
    case DELETE_ADMIN_ALERT_FAILURE:
      return {
        ...state,
        deleting: false,
        deleteError: action.payload,
      };
    default:
      return state;
  }
};

export default adminAlertReducer;
